import React from 'react';
import C18Button00 from './C18Button00'
import C18Anchor00 from './C18Anchor00'
import history from "../../history"
import { wsTrans } from '../utils/utils'
import { uploadTotal } from '../../components/utils/ws'
import { acctFeature, loadAccountInfo, loadZonesInfo, privs, getloadZonesInfo, getZoneInfo, getSiteInfo, getZoneInfo2, getValidWeatherLocation, checkOwner, checkAdmin, } from './C18utils'
import { cl, globs, constant, getRandomString } from '../../components/utils/utils';
import DayClearIcon from '../../visualization/icons/sun-icon.svg';
import NightClearIcon from '../../visualization/icons/moon-icon.svg';
import DayCloudIcon from '../../visualization/icons/day-cloudy-icon.svg';
import NightCloudIcon from '../../visualization/icons/night-cloudy-icon.svg';
import OvercastIcon from '../../visualization/icons/cloud-icon.svg';
import DaySnowIcon from '../../visualization/icons/day-cloud-snow-icon.svg';
import NightSnowIcon from '../../visualization/icons/night-cloud-snow-icon.svg';
import DayRainIcon from '../../visualization/icons/day-cloud-rain-icon.svg';
import NightRainIcon from '../../visualization/icons/night-cloud-rain-icon.svg';
import DayThunderstormIcon from '../../visualization/icons/day-cloud-rain-lightning-icon.svg';
import NightThunderstormIcon from '../../visualization/icons/night-cloud-rain-lightning-icon.svg';
import FunnelIcon from '../../visualization/icons/hurricane-icon.svg';
import { tempUnit } from '../utils/utils';
import {Link, withRouter } from 'react-router-dom'
import InfoPopover from '../../visualization/components/InfoPopover';

class C18DateFormat00 extends React.Component {
  constructor(props) {
    super(props);
//     cl(props)
    this.state = {
      mode: "sites",
      value: props.parms.value,
      weather: (props.parms.weather) ? true : false,
      syncPackInfo: "",
      formatted_address: "",
      isIconHovered: false,
      // isVisible:true,
    }
    //     this.showTimeZone=''
    //     cl("subscribe")
    //     cl(propss)
    if (props.parms.type == "quickWrench") {
      //       cl("subscribe")
      this.subscribe_syncPackInfo = globs.events.subscribe("syncPackInfo", this.syncPackInfo)
    }
    this.loadInfo()
  }
  handleMouseEnter = () => {
    this.setState({ isIconHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isIconHovered: false });
  };
  componentWillUnmount = () => {
    if (this.subscribe_syncPackInfo) { this.subscribe_syncPackInfo.remove() }
  }

  toggleVisibility = () => {
    if(this.props.parms?.onToggle)
      this.props.parms.onToggle();

    // this.setState({ isVisible: !this.state.isVisible })
  }

  syncPackInfo = (cmd) => {
//     cl(cmd)
    let spi=""
    switch(cmd.state){
      case "getConfig":
        spi=`Getting Config`
        break
      case "getCrc":
        spi=`Getting CRCs from Pearl`
        break
      case "getBadIds":
        spi=`Getting Bad Ids from Pearl`
        break
      case "getEquip":
        spi=`Getting Equipment Types from Pearl, ch: ${cmd.curPack}`
        break
      case "getPack":
        spi=`Synchronizing Packs: ${cmd.packsRem} to go, Current Pack: ${cmd.curPack}`
        break
      case "finding":
        spi=`Found ${cmd.packsRem} bad packs so far. . .`
        break
      default:
        break
    }
    this.setState({syncPackInfo:spi})
  }

  toggleMapView=(mode)=>{
//     cl(mode)
    let pa=this.props.parms
    this.props.parms.onChange({mapView:!pa.mapView})

  }

  // open the physical view of this zone/site, making a new one if it doesn't have one yet
  physViewClick = () => {
    let pa = this.props.parms
    let viewId = pa.viewId
    if (viewId) {
      history.push(`/usa/c18/reports/viewView/${viewId}`)
      return
    }
//     cl("making a new view")
    // create a new view with a fixed id that will be associated with this id in the future
    viewId = getRandomString(16)
    // associate view id to site/zone
    if (pa.zoneId) {
      // save local
      let zi = getZoneInfo2(pa.zoneId)[0]
      if (zi) { zi.viewId = viewId }
      // to db
      wsTrans("usa", {cmd: "cRest", uri: "/s/zones", method: "update",
        sessionId: globs.userData.session.sessionId, body: {zoneId: pa.zoneId, viewId: viewId}})
    } else if (pa.siteId) {
      // save local
      let si = getSiteInfo(pa.siteId)
      if (si) { si.viewId = viewId }
      // to db
      wsTrans("usa", {cmd: "cRest", uri: "/s/sites", method: "update",
        sessionId: globs.userData.session.sessionId, body: {siteId: pa.siteId, viewId: viewId}})
    }
    history.push(`/usa/c18/reports/editView/${viewId}`)
  }

  listTileClick = (mode) => {
    var value
    let vals = {}
    switch (mode) {
      case "list-button":
      case "grid-button":
        value = mode.split("-")[0] + "-select"
        break
      case "phys-button":
        // take user to zone-designated view
        this.physViewClick()
        return
      case "godot-button":
        // redirect user to account/site selector
        let url = "https://c2dt.link4cloud.com/"
        if (this.props.parms.apiKey) {
          // cl(this.props.parms.apiKey)
          url = url + this.props.parms.apiKey
        }
        if (this.props.parms.siteId) {
          // cl(this.props.parms.siteId)
          url = url + `~${this.props.parms.siteId}`
        }
        if (this.props.parms.zoneId) {
          // cl(this.props.parms.zoneId)
          url = url + `~${this.props.parms.zoneId}`
        }
        // cl(url)
        window.open(url, "_blank", 'noopener,noreferrer')
        return
      default:
        break
    }
    this.setState({ value: value })
    vals[this.props.parms.valueId] = value
//         cl(vals)
    this.props.parms.onChange(vals)
  }

  wrenchClick = (val, e) => {
//     cl(val)
    e.preventDefault()
    this.props.parms.onChange(val)
  }

  loadInfo = async () => {
    if (this.state.weather) {
      let owner = checkOwner()
      let admin = await checkAdmin()
      let body = { endpoint: "forecast" }
      let matching_source = true
      if (this.props.parms.siteId) {
        let siteLocation = getValidWeatherLocation("site", this.props.parms.siteId)
        Object.assign(body, siteLocation)
        matching_source = siteLocation.siteId === this.props.parms.siteId
      } else {
        let accountLocation = getValidWeatherLocation()
        Object.assign(body, accountLocation)
      }
      if (body.coordinates || body.address || body.postalCode) {
        let forecast = await wsTrans("usa", {
          cmd: "cRest", uri: "/s/weather", method: "retrieve",
          sessionId: globs.userData.session.sessionId, body: body
        })
        this.setState({ forecast: forecast.data?.properties, formatted_address: forecast.data?.formatted_address, matching_source: matching_source, owner: owner, admin: admin })
        this.props.parms.onChange({ forecast: forecast.data?.properties })
      }
    }
  }

  findMatchingWord(sentence) {

    const wordList = [
      'sunny',
      'fair',
      'clear',
      'windy',
      'breezy',
      'clouds',
      'cloudy',
      'overcast',
      'snow',
      'ice',
      'rain',
      'drizzle',
      'showers',
      'thunderstorm',
      'pellets',
      'funnel',
      'tornado',
      'hurricane',
      'storm',];

    const lowercaseSentence = sentence.toLowerCase();
    for (let i = 0; i < wordList.length; i++) {
      if (lowercaseSentence.includes(wordList[i])) {
        return wordList[i];
      }
    }
    return wordList[0];
  }

  makeWeatherIconsEnum = (forecastedSentence, isDaytime) => {

    const sentence = forecastedSentence;
    const matchingWord = this.findMatchingWord(sentence);
    let forecastedIcon = [];

    if (isDaytime) {
      let icons = {
        "sunny": DayClearIcon,
        'fair': DayClearIcon,
        'clear': DayClearIcon,
        'windy': DayClearIcon,
        'breezy': DayClearIcon,
        'clouds': DayCloudIcon,
        'cloudy': DayCloudIcon,
        'overcast': OvercastIcon,
        'snow': DaySnowIcon,
        'ice': DaySnowIcon,
        'rain': DayRainIcon,
        'drizzle': DayRainIcon,
        'showers': DayRainIcon,
        'thunderstorm': DayThunderstormIcon,
        'pellets': DayThunderstormIcon,
        'funnel': FunnelIcon,
        'tornado': FunnelIcon,
        'hurricane': FunnelIcon,
        'storm': FunnelIcon,
      }
      forecastedIcon = icons[matchingWord]
    }

    else {
      let icons = {
        "sunny": NightClearIcon,
        'fair': NightClearIcon,
        'clear': NightClearIcon,
        'windy': NightClearIcon,
        'breezy': NightClearIcon,
        'clouds': NightCloudIcon,
        'cloudy': NightCloudIcon,
        'overcast': OvercastIcon,
        'snow': NightSnowIcon,
        'ice': NightSnowIcon,
        'rain': NightRainIcon,
        'drizzle': NightRainIcon,
        'showers': NightRainIcon,
        'thunderstorm': NightThunderstormIcon,
        'pellets': NightThunderstormIcon,
        'funnel': FunnelIcon,
        'tornado': FunnelIcon,
        'hurricane': FunnelIcon,
        'storm': FunnelIcon,
      }

      forecastedIcon = icons[matchingWord]
    }

    return forecastedIcon;
  }

  showListTile = () => {
    let pa=this.props.parms
//     cl(pa)
    //     cl(this.state)
    var listSelect = "", gridSelect = "", physSelect = "", godotSelect = ""
    //     if(this.state.value){// value is "tileMode"
    //       gridSelect=" selected"
    //     }else{
    //       listSelect=" selected"
    //     }
    let selected = " selected"
    if (this.state.value == "list-select") { listSelect = selected }
    if (this.state.value == "grid-select") { gridSelect = selected }
//     if (this.state.value == "phys-select") { physSelect = selected }
    if(pa.mapView){ physSelect = selected }
    if (this.state.value == "godotSelect") { godotSelect = selected }

    return (
      <div className="section-controls">
        {/* {false && acctFeature("godotView") &&
          <C18Button00 type="button" className={`phys-button material-icons${godotSelect}`} aria-pressed="false"
            onClick={() => { this.listTileClick("godot-button") }}>3d_rotation</C18Button00>
        } */}
        {(true||this.props.parms.siteId || this.props.parms.zoneId) &&
          <C18Button00 id="google-map-view" type="button" className={`phys-button material-icons${physSelect}`} translate="no" aria-pressed="false"
            onClick={() => { this.toggleMapView("phys-button") }}>map</C18Button00>
        }
        {/* Physical View is disabled for all users for now; keep this block for future use.
        {(this.props.parms.siteId || this.props.parms.zoneId) &&
          <C18Button00 id="physical-view" type="button" className="phys-button material-icons" translate="no" aria-pressed="false"
            title="Physical View" onClick={() => { this.listTileClick("phys-button") }}>preview</C18Button00>
        } */}
        <C18Button00 type="button" className={`grid-button material-icons${gridSelect}`} translate="no" aria-label="grid"
          aria-pressed="true" title="Grid View" onClick={() => { this.listTileClick("grid-button") }}>apps</C18Button00>
        <C18Button00 type="button" className={`list-button material-icons${listSelect}`} translate="no" aria-pressed="false"
          title="List View" onClick={() => { this.listTileClick("list-button") }}>view_list</C18Button00>
        {/* Commenting out / Removing this feature for Now as per C20C22-1922 */}
        {false && acctFeature("physView") &&
          <C18Button00 type="button" className={`phys-button material-icons${physSelect}`} aria-pressed="false"
            onClick={() => { this.listTileClick("phys-button") }}></C18Button00>
        }
        
      </div>
    )
  }

  showWrench = () => {
    //     cl("show")
//     cl("wrench")
//     cl(this.props.parms)
    return (
      <div id="/zone/zoneEquipment/equipmentSettings" className="section-controls">
        {!this.props.parms.isHR16 && (
          <C18Anchor00 id="/zone/zoneSensors/stages" to="" className="quick-charts" aria-label="quick-charts"
            onClick={e => this.wrenchClick({ wrenchCmd: "stages" }, e)} >
            <span className="material-icons-outlined" translate="no">
              show_chart
            </span>
            <span className="quick-charts">Stages</span>
        </C18Anchor00>)}
        <C18Anchor00 to=""
          className="settings-button material-icons-outlined flip"
          aria-label={this.props.parms.ariaLabel}
          translate="no"
          style={{ position: "relative", zIndex: 5 }}
          onClick={e => this.wrenchClick({ wrenchCmd: "wrench" }, e)} translate="no">settings</C18Anchor00>
      </div>
    )
  }

  getUploadColor = () => {
    var uploadColor
    //     cl(uploadTotal)
    if (uploadTotal > 15) {
      if (uploadTotal > 30) {
        uploadColor = "#FF8888"
      } else {
        uploadColor = "#FFCC88"
      }
    } else {
      if (uploadTotal > 3) {
        uploadColor = "#FFFF88"
      } else {
        uploadColor = "#88FF88"
      }
    }
    return uploadColor
  }

  showQuickWrench = () => {
    let isSuper = false
    if (privs("super", "", constant.AREA_PRIVS_READ) || (
      (globs.privsInfo.thirdPartyAccounts?.length > 1))) {
      isSuper = true
    }
    //       isSuper=false
    //       cl(isSuper)
    //     cl("show")
    return (
      <div className={`section-controls custom-section-controls${this.props.parms.isIDoser?" has-idoser":""}`}>
        {this.props.parms.isIDoser &&
          <C18Anchor00 id="/zone/zoneSensors/pearlDoser"
            to={`/usa/c18/sites/${this.props.parms.siteId}/zones/${this.props.parms.zoneId}/pearlDoser`}
            className="quick-charts hide-mobile-600" aria-label="pearl-idoser" title="Open Pearl iDoser">
            <span className="material-icons-outlined" translate="no">
              science
            </span>
            <span className="quick-charts">Pearl iDoser</span>
          </C18Anchor00>
        }
        <C18Anchor00 id="/zone/zoneSensors/quickCharts" to="" className="quick-charts hide-mobile-600" aria-label="quick-charts"
          onClick={e => this.wrenchClick({ wrenchCmd: "charts" }, e)} >
          <span className="material-icons-outlined" translate="no">
            signal_cellular_alt
          </span>
          <span className="quick-charts">Quick Charts</span>
        </C18Anchor00>
        <span className="icon-row hide-mobile-600">
        {/* {false && acctFeature("godotView") &&
          <C18Button00 type="button" className={`phys-button material-icons${godotSelect}`} aria-pressed="false"
            onClick={() => { this.listTileClick("godot-button") }}>3d_rotation</C18Button00>
        } */}
        {/* Physical View is disabled for all users for now; keep this block for future use.
        {(this.props.parms.siteId || this.props.parms.zoneId) && !this.props.parms.isHR16 &&
          <C18Button00 type="button" className={`phys-button material-icons`} aria-pressed="false"
            title="Physical View"
            onClick={() => { this.listTileClick("phys-button") }} translate="no" >preview</C18Button00>
        } */}
        <C18Anchor00 id="/zone/zoneSensors/sensorSettings" to=""
          className="settings-button material-icons-outlined flip"
          aria-label={this.props.parms.ariaLabel}
          style={{ position: "relative", zIndex: 5 }}
          onClick={e => this.wrenchClick({ wrenchCmd: "wrench" }, e)} translate="no">settings</C18Anchor00>
        {(([800,1900].includes(this.props.parms.gatewayType)) && isSuper) &&// only on Pearl
          <>
            <C18Anchor00 to="" className="settings-button material-icons-outlined flip"
              aria-label={this.props.parms.ariaLabel}
              title="Force full upload of this Zone"
              style={{ backgroundColor: this.getUploadColor() }}
              onClick={e => this.props.parms.onChange({ e: e, wrenchCmd: "upload" }, e)} translate="no">
              upload</C18Anchor00>
            <C18Anchor00 to="" className="settings-button material-icons-outlined flip"
              aria-label={this.props.parms.ariaLabel}
              title="Delete all zone data"
              style={{ backgroundColor: "#FFCCCC" }}
              onClick={e => this.props.parms.onChange({ e: e, wrenchCmd: "eraseDB" }, e)} translate="no">
              delete</C18Anchor00>
          </>
        }
        </span>
      </div>
    )
  }

  showRightElement = () => {
    //     cl(this.props.parms)
    switch (this.props.parms.type) {
      case "listTile":
        return this.showListTile()
      case "quickWrench":
        return this.showQuickWrench()
      case "wrench":
        return this.showWrench()
      default:
        return null
    }
  }

  showForecast = () => {
    if (this.state.forecast) {
      const { isIconHovered } = this.state;
      const locationIconStyle = {
        backgroundColor: isIconHovered ? 'rgba(0, 0, 0, 0.1)' : 'transparent', // Change to desired hover color
        transition: 'background-color 0.3s ease',
        display: 'inline-flex',
        alignItems: 'center',
        textDecoration: 'none',
      };
      let units = {
        "degF": String.fromCharCode(176) + "F",
        "degC": String.fromCharCode(176) + "C",
        "percent": "%",
      }

      let si = getSiteInfo(this.props.parms.siteId)
      //     cl(si)
      let weatherStation = si?.weatherStation || this.props.parms.zoneId
          //     cl(weatherStation)
      let zi = getZoneInfo2(weatherStation)
      //     cl(zi)
      let wsz = (zi[0] || {}).siteZoneIndex || 0
      let outTempUnits = tempUnit(wsz).t


      let curr = this.state.forecast.periods[0] // today forecast
      let finaltemperature;
      if (outTempUnits === "°" + curr.temperatureUnit) {
        finaltemperature = `${curr.temperature}\u00B0${curr.temperatureUnit}`
      }
      else {
        if (outTempUnits === '°F') {
          let temp = (curr.temperatureUnit * 9 / 5) + 32;
          finaltemperature = `${temp.toFixed()}${outTempUnits}`
        }
        else {
          let temp = (curr.temperatureUnit - 32) * 5 / 9;
          finaltemperature = `${temp.toFixed()}${outTempUnits}`

        }
      }

      // let name = curr.name
      let temp = finaltemperature
      let short_forecast = curr.shortForecast
      // let detailed_forecast = curr.detailedForecast
      // let wind_dir = curr.windDirection
      // let wind_spd = curr.windSpeed
      // let pop = `${curr.probabilityOfPrecipitation.value} ${units[curr.probabilityOfPrecipitation.unitCode.split(":")[1]]}`
      // let dewpoint = `${curr.dewpoint.value} ${units[curr.dewpoint.unitCode.split(":")[1]]}`
      // let rh = `${curr.relativeHumidity.value} ${units[curr.relativeHumidity.unitCode.split(":")[1]]}`

      let icon = this.makeWeatherIconsEnum(curr.shortForecast || "", curr.isDaytime)
      // cl([this.state.owner, this.state.admin, this.state.owner || this.state.admin])
      return (
        <span className='hide-mobile' style={{ display: "flex", alignItems: "center", marginLeft: "5px" }}>
          <img src={icon} width="30px" style={{ marginRight: "5px" }} />
          <span style={{ marginRight: "10px", color: "#393D46" }}>{temp}</span>
          <span style={{ marginRight: "10px", color: "#393D46" }}>({short_forecast})</span>
          <span className="material-icons" title={this.state.formatted_address} style={{ marginLeft: "1px" }}>
            {/* only let admin/owner click the link */}
            {(this.state.owner || this.state.admin) ?
            <Link
              to={{
                pathname: (this.props.parms.parent === "sites") ? "/usa/c18/admin/manageAccount2" : "/usa/c18/admin/manageSites2",
                state: { from: this.props.location.pathname }
              }}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              >
                <span
                  className="material-icons"
                  style={locationIconStyle}>
                  {(this.state.matching_source && this.state.formatted_address) ? "location_on" : "wrong_location"}
                </span>
            </Link>
            :
            <span
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              >
                <span
                  className="material-icons"
                  style={locationIconStyle}>
                  {(this.state.matching_source && this.state.formatted_address) ? "location_on" : "wrong_location"}
                </span>
            </span>
            }
          </span>
        </span>
        )
    }
  }

  showSyncPacks = () => {
    let st = this.state
    if (st.syncPackInfo) {
      return (
        <div className="section-header" style={{ paddingLeft: 50, backgroundColor: "#EEEEEE", display: "flex", width: "100%" }}>
          {st.syncPackInfo}
        </div>
      )
    }
  }

  showDateFormat = () => {
    let pa = this.props.parms
//     cl(pa)
//     cl(this.props.parms)

    //    if (this.props.parms.timeZone) {
    //     this.showTimeZone = <div style={{
    //       float: "left",
    //       lineHeight: "40px",
    //       fontSize: "16px",
    //       fontWeight: "500",
    //       paddingLeft: "10px"
    //     }}>({this.props.parms.timeZone})</div>
    //    }
    //     let tz=this.props.parms.timeZone
    let tzPart = (pa.timeZone) ? ` (${pa.timeZone})` : ""
    let dateShow = `${pa.leftString}${tzPart}`
//     cl(dateShow)
    //         {this.showTimeZone}
    let dateWithoutUTC = pa.leftString.replace(/\(UTC.*\)/, "").trim();

    return (
      <>
        <div
          className="section-header"
          style={{  width: '100%'}}
        >
          <div
          className={`weather-line ${this.props.parms.leftClass}`}
            id={`date-${pa.parent}`}
   
          >      
        {pa.type !== "quickWrench" &&  pa.leftString !== "Equipment" && <span>{dateShow}</span>}   
        {/* Only show this if type is "quickWrench" */}
         {pa.type === "quickWrench" && (
          <>
         <div className="date-container">
        {/* time without UTC for sm */}
        <span className="hide-desktop">{dateWithoutUTC}</span>
        <div>
         <InfoPopover fullDate={dateShow} />
         {pa.isIDoser &&
           <C18Anchor00 id="/zone/zoneSensors/pearlDoserMobile"
             to={`/usa/c18/sites/${pa.siteId}/zones/${pa.zoneId}/pearlDoser`}
             className="quick-charts hide-desktop" aria-label="pearl-idoser" title="Open Pearl iDoser">
             <span className="material-icons-outlined button-css" translate="no">
               opacity
             </span>
           </C18Anchor00>
         }
         <C18Anchor00 id="/zone/zoneSensors/quickCharts" to=""  className="quick-charts hide-desktop" aria-label="quick-charts"
          onClick={e => this.wrenchClick({ wrenchCmd: "charts" }, e)}>
          <span className="material-icons-outlined button-css">
            signal_cellular_alt
          </span>
          {/* <span className="quick-charts">Quick Charts</span> */}
        </C18Anchor00>
        <C18Anchor00 id="/zone/zoneSensors/sensorSettings" to=""
          className="settings-button material-icons-outlined flip button-css hide-desktop"
          aria-label={this.props.parms.ariaLabel}
          style={{ position: "relative", zIndex: 5}}
          onClick={e => this.wrenchClick({ wrenchCmd: "wrench" }, e)}>settings</C18Anchor00>
        </div>
        </div>
         {/* Full Date for lg */}
         <span className="hide-mobile-600">{dateWithoutUTC}</span>
       </>
        )}
        {/* Equipment text visible */}
        {pa.leftString === "Equipment"&& (
        <div style={{ display: "inline-block" }}>{pa.leftString}</div>
        )}
           {this.props.parms.type === 'wrench' ? (
              <i
              translate="no"
                onClick={() => this.toggleVisibility()}
                style={{ marginRight: '2px', marginLeft: '2px', cursor: 'pointer' }}
                className="material-icons"
                title={this.props.parms.value ? 'Show All' : 'Hide None'}
                translate="no"
              >
                {this.props.parms.value ? 'visibility_off' : 'visibility'}

              </i>
            ) : (
              ''
            )}
            <span
              className="material-icons-outlined not-connected-icon"
              title="Zone is Offline"
              translate="no"
            >
              report_problem
            </span>
            {this.showForecast()}
          </div>
          <div style={{ flex: 1, marginLeft: '10px', minWidth: "fit-content"}}>
            {this.showRightElement()}
          </div>
        </div>
        {this.showSyncPacks()}
      </>
    );
  }


  render() {
    return this.showDateFormat()
  }
}

export default withRouter(C18DateFormat00);
